package uk.co.nickthecoder.kyd.nodes

import uk.co.nickthecoder.glok.event.MouseEvent
import uk.co.nickthecoder.glok.util.Matrix
import uk.co.nickthecoder.kyd.Actor
import uk.co.nickthecoder.kyd.MouseBehaviour
import uk.co.nickthecoder.kyd.Stage
import uk.co.nickthecoder.kyd.util.Vector2
import kotlin.math.round
import uk.co.nickthecoder.kyd.events.MouseEvent as KydMouseEvent

class PlayStageView(stage: Stage) : StageView(stage) {

    private var mouseCapturedBy: Triple<Stage, Actor, MouseBehaviour>? = null


    override fun drawActor(actor: Actor, localToWorld: Matrix) {
        if (actor.visible) {
            super.drawActor(actor, localToWorld)
        }
    }

    // region == Mouse Events ==

    protected fun worldPoint(event: MouseEvent): Vector2 {
        // When using a high-DPI screen, mouse events can return fractional values. We don't want them!
        val sceneX = round(event.sceneX)
        val sceneY = round(event.sceneY)
        return Vector2(sceneX, sceneY) * sceneToWorld
    }

    fun mousePressed(event: MouseEvent) : Boolean {

        val world = worldPoint(event)
        val kydEvent = KydMouseEvent(event, world)

        for (actor in stage.actors.asReversed()) {
            val behaviour = actor.behaviour as? MouseBehaviour ?: continue
            val local = world * actor.worldToLocal

            if (behaviour.isMouseEnabled) {
                if (behaviour.touchTest.touching(actor, local)) {
                    kydEvent.local = local
                    val consumed = behaviour.onMousePressed(actor, kydEvent)
                    if (kydEvent.captured) {
                        mouseCapturedBy = Triple(stage, actor, behaviour)
                        event.capture()
                        return true
                    }
                    if (consumed) {
                        return true
                    }
                }
            }
        }
        return false
    }

    fun mouseReleased(event: MouseEvent) {
        mouseCapturedBy?.let {
            val (stage, actor, behaviour) = it
            val world = worldPoint(event)

            val kydEvent = KydMouseEvent(event, world)
            kydEvent.local = world * actor.worldToLocal

            behaviour.onMouseReleased(actor, kydEvent)
        }
        mouseCapturedBy = null
    }

    fun mouseDragged(event: MouseEvent) {
        mouseCapturedBy?.let {
            val (stage, actor, behaviour) = it
            val world = worldPoint(event)

            val kydEvent = KydMouseEvent(event, world)
            kydEvent.local = world * actor.worldToLocal

            behaviour.onMouseDragged(actor, kydEvent)
        }
    }

    fun mouseClicked(event: MouseEvent) : Boolean{
        val world = worldPoint(event)
        val kydEvent = KydMouseEvent(event, world)

        for (actor in stage.actors.asReversed()) {
            val behaviour = actor.behaviour as? MouseBehaviour ?: continue
            val local = world * actor.worldToLocal

            if (behaviour.isMouseEnabled) {
                if (behaviour.touchTest.touching(actor, local)) {
                    kydEvent.local = local
                    if (behaviour.onMouseClicked(actor, kydEvent)) {
                        return true
                    }
                }
            }
        }
        return false
    }

    // endregion Mouse Events

}
